import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export function withAuthAdmin(Component) {
  return function ProtectedRoute(props) {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(null); // Start with null to indicate loading

    useEffect(() => {
      const checkAuthentication = async () => {
        // Check for adminKey in cookies first
        const adminKey = Cookies.get('adminKey');
        if (!adminKey) {
          setIsAdmin(false);
          navigate('/');
          return;
        }

        // If adminKey exists, verify with backend
        try {
          const isAdminUser = await checkAuthAdmin();
          setIsAdmin(isAdminUser);
          if (!isAdminUser) {
            navigate('/');
          }
        } catch (error) {
          console.error("Error checking admin status:", error);
          // Handle the error appropriately (e.g., redirect to an error page)
        }
      };

      checkAuthentication();
    }, [navigate]); // Only run on mount and when 'navigate' changes

    // Conditionally render based on authentication status
    if (isAdmin === null) {
      return <div></div>; // Or a more appropriate loading indicator
    } else if (isAdmin) {
      return <Component {...props} />;
    } else {
      return null; // Don't render anything if not admin
    }
  };
}

export function checkAuth() {
  const accessToken = Cookies.get('accessToken');
  return !!accessToken;
}

async function checkAuthAdmin() {
  try {
    const accessToken = Cookies.get('accessToken');
    const response = await fetch(process.env.REACT_APP_BACKEND_URI + "user/self?accessToken=" + accessToken);

    if (!response.ok) { // Check for HTTP errors (e.g., 401, 403, 500)
      console.error("HTTP error checking admin status:", response.status);
      return false; 
    }

    const data = await response.json();
    if (data.role === 'admin' || data.role === 'owner') {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
}